import { CSSProperties } from "react";

interface SkeletonShimmerProps {
    className?: string;
    style?: CSSProperties;
    /** Light gray for cards/content; dark solid for hero banners */
    variant?: "light" | "dark";
    "aria-hidden"?: boolean;
}

/** Placeholder for dev preview routes — not used in production page flows */
export function SkeletonShimmer({
    className = "",
    style,
    variant = "light",
    "aria-hidden": ariaHidden = true,
}: SkeletonShimmerProps) {
    const variantClass =
        variant === "dark" ? "skeleton-shimmer-dark" : "skeleton-shimmer";

    return (
        <div
            className={`${variantClass} ${className}`.trim()}
            style={style}
            aria-hidden={ariaHidden}
        />
    );
}

/** Article-style skeleton for dev preview only (`/loading-preview`) */
export function PageContentSkeleton() {
    return (
        <div className="min-h-screen bg-white">
            <SkeletonShimmer className="h-[460px] w-full rounded-none" />
            <div className="m-auto w-full max-w-[1072px] px-8 py-16 lg:px-0">
                <SkeletonShimmer className="mb-4 h-8 w-2/5 max-w-sm rounded-lg" />
                <SkeletonShimmer className="mb-8 h-4 w-3/5 max-w-md rounded-md" />
                <div className="grid grid-cols-1 gap-10 lg:grid-cols-2">
                    <div className="space-y-3">
                        <SkeletonShimmer className="h-4 w-full rounded-md" />
                        <SkeletonShimmer className="h-4 w-[92%] rounded-md" />
                        <SkeletonShimmer className="h-4 w-[85%] rounded-md" />
                        <SkeletonShimmer className="h-4 w-[78%] rounded-md" />
                    </div>
                    <SkeletonShimmer className="aspect-[4/3] w-full rounded-2xl" />
                </div>
            </div>
        </div>
    );
}
